export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/food_and_beverage.0edf584.svg";